import { Player } from './players';
import { PlayersPresetsApi, PlayersPreset } from './presets';

export class LocalStoragePlayersPresetsApi implements PlayersPresetsApi {
  static #LOCAL_STORAGE_KEY = 'player-presets';

  #presets: PlayersPreset[] = [];

  constructor(private localStorage = window.localStorage) {
    this.load();
  }
  async add(players: Player[]): Promise<PlayersPreset> {
    let id = Date.now().toString();
    const preset: PlayersPreset = {
      id,
      players: players.map(
        (p) =>
          ({
            name: p.name,
          } satisfies Player)
      ),
    };
    this.#presets.push(preset);
    this.store();
    return {
      id,
      players: players.map(
        (p) =>
          ({
            name: p.name,
          } satisfies Player)
      ),
    };
  }
  async remove(id: string): Promise<void> {
    this.#presets = this.#presets.filter((p) => p.id !== id);
    this.store();
  }

  async list(): Promise<PlayersPreset[]> {
    return [...this.#presets];
  }

  private load(): void {
    const data = this.localStorage.getItem(
      LocalStoragePlayersPresetsApi.#LOCAL_STORAGE_KEY
    );
    if (data == null) {
      return;
    }

    try {
      this.#presets = JSON.parse(data);
    } catch {
      this.#presets = [];
    }
  }

  private store(): void {
    this.localStorage.setItem(
      LocalStoragePlayersPresetsApi.#LOCAL_STORAGE_KEY,
      JSON.stringify(this.#presets)
    );
  }
}
